import { Directive } from '@angular/core';

/**
 * Fila de la barra de filtros de una pantalla: filtros a la izquierda y acciones (reporte, vistas) a la derecha.
 * Deja 16 px entre grupos y 24 px hasta el contenido (tokens `filters` y `filters-content` de tailwind.config.js),
 * así que la plantilla que la usa no agrega márgenes propios.
 * Si los controles no caben, los grupos pasan a la línea siguiente en vez de cortarse; en móvil van centrados.
 * Cada grupo usa `mhFilterGroup` y cada control `mhFilterTrigger`.
 */
@Directive({
  selector: '[mhFilterBar]',
  standalone: true,
  host: {
    class:
      'tw-mb-filters-content tw-flex tw-flex-wrap tw-items-center tw-justify-center tw-gap-filters md:tw-justify-between',
  },
})
export class FilterBarDirective {}

/** Grupo de controles dentro de `mhFilterBar`: 16 px entre controles y salto de línea si no caben. */
@Directive({
  selector: '[mhFilterGroup]',
  standalone: true,
  host: {
    class: 'tw-flex tw-flex-wrap tw-items-center tw-justify-center tw-gap-filters md:tw-justify-start',
  },
})
export class FilterGroupDirective {}
